import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import NotificationTwoToneSvg from "@ant-design/icons-svg/es/asn/NotificationTwoTone";
import AntdIcon from "../components/AntdIcon";
var NotificationTwoTone = function NotificationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NotificationTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  NotificationTwoTone.displayName = 'NotificationTwoTone';
}
export default /*#__PURE__*/React.forwardRef(NotificationTwoTone);